// ----
// ref - https://codepen.io/idorenyinudoh/pen/GRjBXER
// ----

const audioPlayer = document.querySelectorAll('.audio-player');

window.addEventListener('load', (event) => {

  const pauseOtherAudio = () => {
    const otherAudio = document.querySelectorAll('.audio-player__audio');
    otherAudio.forEach((item) => {
      const parentElem = item.closest('.audio-player');
      const audioPlayIcon = parentElem.querySelector('.audio-player__play');
      item.pause();
      audioPlayIcon.classList.remove('is-playing');
      cancelAnimationFrame(null);
    });
  }

  audioPlayer.forEach((element) => {
    const audioPlayerContainer = element;
    const playIconContainer = element.querySelector('.audio-player__play');
    const audioElem = element.querySelector('.audio-player__audio');
    const seekSlider = element.querySelector('.audio-player__seek-slider');
    const durationContainer = element.querySelector('.audio-player__time-total');
    const currentTimeContainer = element.querySelector('.audio-player__time-current');
    let raf = null;

    const calculateTime = (secs) => {
      const minutes = Math.floor(secs / 60);
      const seconds = Math.floor(secs % 60);
      const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
      return `${minutes}:${returnedSeconds}`;
    };

    const whilePlaying = () => {
      seekSlider.value = Math.floor(audioElem.currentTime);
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      audioPlayerContainer.style.setProperty('--seek-before-width', `${(seekSlider.value / seekSlider.max) * 100}%`);
      raf = requestAnimationFrame(whilePlaying);
    };

    const playAudio = () => {
      audioElem.play();
      playIconContainer.classList.add('is-playing');
      requestAnimationFrame(whilePlaying);
    };

    const pauseAudio = () => {
      audioElem.pause();
      playIconContainer.classList.remove('is-playing');
      cancelAnimationFrame(raf);
    };

    playIconContainer.addEventListener('click', () => {
      const isPlaying = playIconContainer.classList.contains('is-playing');
      if (!isPlaying) {
        pauseOtherAudio();
        playAudio();
      } else {
        pauseAudio();
        pauseOtherAudio();
      }
    });

    attachEvent('[data-tab]', 'click', (ev) => {
      pauseAudio();
    });

    const showRangeProgress = (rangeInput) => {
      if (rangeInput === seekSlider) {
        audioPlayerContainer.style.setProperty('--seek-before-width', `${(rangeInput.value / rangeInput.max) * 100}%`);
      }
    };

    seekSlider.addEventListener('input', (e) => {
      showRangeProgress(e.target);
    });

    const displayDuration = () => {
      durationContainer.textContent = calculateTime(audioElem.duration);
    };

    const setSliderMax = () => {
      seekSlider.max = Math.floor(audioElem.duration);
    };

    const displayBufferedAmount = () => {
      if (audioElem.buffered.length) {
        const bufferedAmount = Math.floor(audioElem.buffered.end(audioElem.buffered.length - 1));
        audioPlayerContainer.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.max) * 100}%`);
      }
    };

    const audioEnd = () => {
      audioElem.addEventListener('ended', () => {
        playIconContainer.classList.remove('is-playing');
      });
    };

    const audioFunctions = () => {
      displayBufferedAmount();
      displayDuration();
      setSliderMax();
      audioEnd();
    };

    if (audioElem.readyState > 0) {
      audioFunctions();
    } else {
      audioElem.addEventListener('loadedmetadata', () => {
        audioFunctions();
      });
    }

    audioElem.addEventListener('progress', displayBufferedAmount);

    seekSlider.addEventListener('input', () => {
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      if (!audioElem.paused) {
        cancelAnimationFrame(raf);
      }
    });

    seekSlider.addEventListener('change', () => {
      audioElem.currentTime = seekSlider.value;
      if (!audioElem.paused) {
        requestAnimationFrame(whilePlaying);
      }
    });
  });
});
